import { render } from "./CompleteDispatch.vue?vue&type=template&id=5fac798c&scoped=true"
import script from "./CompleteDispatch.vue?vue&type=script&lang=js"
export * from "./CompleteDispatch.vue?vue&type=script&lang=js"

import "./CompleteDispatch.vue?vue&type=style&index=0&id=5fac798c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fac798c"]])

export default __exports__